export default {
  jp: {
    title: {
      entryComplete: '申請完了',
      registComplete: '登録完了',
      modifyConfirm: '変更確認',
      modifyComplete: '変更完了',
      deleteConfirm: '削除確認',
      deleteComplete: '削除完了',
      rejectConfirm: '却下確認',
      rejectComplete: '却下完了',
      approvalConfirm: '承認確認',
      approvalComplete: '承認完了',
      rejectListConfirm: '却下確認',
      rejectListComplete: '却下完了',
      approvalListConfirm: '承認確認',
      approvalListComplete: '承認完了',
      resetListConfirm: 'パスワードリセット確認',
      resetListComplete: 'パスワードリセット完了',
      requireSelect: '選択エラー',
      reminderComplete: 'パスワード再発行完了',
      inputConfirm: '入力内容の確認',
      sendMailComplete: '送信完了'
    },
    label: {
    },
    ph: {
    },
    button: {
      cancel: 'キャンセル',
      ok: 'OK'
    },
    desc: {
      entryComplete: '申請を受け付けました。',
      registComplete: '登録が完了しました。',
      modifyConfirm: '変更します。よろしいでしょうか。',
      modifyComplete: '変更が完了しました。',
      deleteConfirm: '削除します。よろしいでしょうか。',
      deleteComplete: '削除が完了しました。',
      rejectConfirm: '却下します。よろしいでしょうか。',
      rejectComplete: '却下が完了しました。',
      approvalConfirm: '承認します。よろしいでしょうか。',
      approvalComplete: '承認が完了しました。',
      rejectListConfirm: '選択したアカウントを却下します。よろしいでしょうか。',
      rejectListComplete: '選択したアカウントの却下が完了しました。',
      approvalListConfirm: '選択したアカウントを承認します。よろしいでしょうか。',
      approvalListComplete: '選択したアカウントの承認が完了しました。',
      resetListConfirm: '選択したアカウントのパスワードリセットを実施します。よろしいでしょうか。',
      resetListComplete: '選択したアカウントのパスワードリセットが完了しました。',
      requireSelect: 'アカウントを選択してください。',
      reminderComplete: 'パスワード再発行が完了いたしました。',
      inputConfirm: 'こちらの内容でよろしいでしょうか。',
      sendMailComplete: '送信が完了しました。'
    }
  },
  en: {
    title: {
      entryComplete: 'Application completed',
      registComplete: 'Registered',
      modifyConfirm: 'Confirm Change',
      modifyComplete: 'Changed',
      deleteConfirm: 'Confirm Delete',
      deleteComplete: 'Deleted',
      rejectConfirm: 'Confirm Rejection',
      rejectComplete: 'Rejected',
      approvalConfirm: 'Confirm Approval',
      approvalComplete: 'Approved',
      rejectListConfirm: 'Confirm Rejection',
      rejectListComplete: 'Rejected',
      approvalListConfirm: 'Confirm Approval',
      approvalListComplete: 'Approved',
      resetListConfirm: 'Confirm Password reset',
      resetListComplete: 'Password has been reset',
      requireSelect: 'Selection Error',
      reminderComplete: 'Password has been reissued',
      inputConfirm: 'Confirm Contents',
      sendMailComplete: 'Sended'
    },
    label: {
    },
    ph: {
    },
    button: {
      cancel: 'Cancel',
      ok: 'OK'
    },
    desc: {
      entryComplete: 'Application accepted',
      registComplete: 'Registered',
      modifyConfirm: 'Confirm change',
      modifyComplete: 'Changed',
      deleteConfirm: 'Confirm deletion',
      deleteComplete: 'Deleted',
      rejectConfirm: 'Confirm rejection',
      rejectComplete: 'Rejected',
      approvalConfirm: 'Confirm approval',
      approvalComplete: 'Approved',
      rejectListConfirm: 'Confirm rejection of account selected',
      rejectListComplete: 'Rejected selected account',
      approvalListConfirm: 'Confirm approval of account selected',
      approvalListComplete: 'Approved account selected',
      resetListConfirm: '選択したアカウントのパスワードリセットを実施します。よろしいでしょうか。',
      resetListComplete: '選択したアカウントのパスワードリセットが完了しました。',
      requireSelect: 'アカウントを選択してください。',
      reminderComplete: 'Your password has been reissued.',
      inputConfirm: 'Are you sure you entered your contents correctly?',
      sendMailComplete: 'Sended'
    }
  }

}
